/**
 * Mirrors `packages/analytics-api` game filter query params. Keep slug rules aligned with
 * `playableRouteSlugFromPath` in `event-properties.ts`.
 */
export const GAME_FILTER_SLUG_PREFIX = "sg:";
export const GAME_FILTER_NAME_PREFIX = "gn:";

const PLAYABLE_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** Keep aligned with `playableRouteSlugFromPath` in analytics-api `event-properties.ts`. */
export function playableRouteSlugFromPath(route: string): string {
  let trimmed = route.trim();
  const queryAt = trimmed.search(/[?#]/);
  if (queryAt >= 0) trimmed = trimmed.slice(0, queryAt);
  trimmed = trimmed.replace(/\/index\.html?$/i, "").replace(/\/+$/g, "").trim();
  if (!trimmed) return "";

  let seg: string | undefined;
  const games = trimmed.match(/\/games\/([^/]+)/i);
  if (games?.[1]) {
    seg = games[1];
  } else if (!trimmed.includes("://") && /^\/[^/]+$/i.test(trimmed)) {
    seg = trimmed.slice(1);
  } else if (!trimmed.includes("://") && !trimmed.includes("/") && !trimmed.includes(":")) {
    seg = trimmed;
  } else {
    return "";
  }

  const slug = seg
    .replace(/\.html?$/i, "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
  return PLAYABLE_SLUG.test(slug) ? slug : "";
}

export function gameFilterValueFromConceptKey(key: string): string {
  const t = key.trim();
  if (!t || t === "(unknown)") return "all";
  if (t.startsWith("/")) {
    const slug = playableRouteSlugFromPath(t);
    return slug ? `${GAME_FILTER_SLUG_PREFIX}${slug}` : "all";
  }
  return `${GAME_FILTER_NAME_PREFIX}${t}`;
}
